import GrowthSourcesComponent from '../Components/Growth/GrowthSourcesComponent';

function GrowthSourcesPage() {
  return <GrowthSourcesComponent />;
}

export default GrowthSourcesPage;